/**
 * lookbook.js — Faber Maison Shopify Theme
 * Opens a modal when a lookbook card is clicked.
 */

(function () {
  'use strict';

  const modal        = document.getElementById('LookbookModal');
  const modalImg     = document.getElementById('LookbookModalImg');
  const modalCaption = document.getElementById('LookbookModalCaption');
  const modalClose   = document.getElementById('LookbookModalClose');
  const backdrop     = document.getElementById('LookbookModalBackdrop');
  const grid         = document.getElementById('LookbookGrid');

  if (!modal || !grid) return;

  function openModal(imgSrc, altText, caption) {
    modalImg.src = imgSrc;
    modalImg.alt = altText || '';
    if (modalCaption) modalCaption.textContent = caption || '';
    modal.removeAttribute('hidden');
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    modalClose && modalClose.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => modal.setAttribute('hidden', ''), 300);
  }

  // Open on card click
  grid.querySelectorAll('[data-lookbook-color]').forEach((card) => {
    card.addEventListener('click', () => {
      const img = card.querySelector('img');
      if (!img) return;
      const name = card.dataset.lookbookName || '';
      openModal(img.src.replace('300x', '700x').replace('450x', '700x'), name, name);
    });
  });

  modalClose && modalClose.addEventListener('click', closeModal);
  backdrop && backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

})();
